import { z } from 'zod';

import { zodActivationRequestResponseSchema } from '../validations';

/**
 * Zod schema for the GET /suppliers/{de_id}/activation/requests response
 * (DataExchangeActivationListResponse).
 *
 * Returns all activation requests for a data-exchange, ordered newest first.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_activation_requests_for_de_suppliers__de_id__activation_requests_get
 */
export const zodSupplierActivationRequestsResponseSchema = z.object({
  requests: z.array(zodActivationRequestResponseSchema),
});
